/**
 * Map category slugs to display labels.
 * Also handles legacy un-slugified values for backward compatibility.
 */
const CATEGORY_MAP = {
  'nature-parks': 'Nature & Parks',
  'hidden-gems': 'Hidden Gems',
  'architecture': 'Architecture',
  'food-focused-walks': 'Food-Focused Walks',
  'scenic-walks': 'Scenic Walks',
  'historic-walks': 'Historic Walks',
  'family-friendly': 'Family-Friendly',
  'sunset-walks': 'Sunset Walks',
};

const CATEGORY_COLORS = {
  // By display label
  'Architecture': '#DC2626',
  'Hidden Gems': '#F59E0B',
  'Scenic Walks': '#0D9488',
  'Historic Walks': '#92400E',
  'Food-Focused Walks': '#6D28D9',
  'Nature & Parks': '#16A34A',
  'Family-Friendly': '#2563EB',
  'Sunset Walks': '#EA580C',
  // By slug
  'architecture': '#DC2626',
  'hidden-gems': '#F59E0B',
  'scenic-walks': '#0D9488',
  'historic-walks': '#92400E',
  'food-focused-walks': '#6D28D9',
  'nature-parks': '#16A34A',
  'family-friendly': '#2563EB',
  'sunset-walks': '#EA580C',
  'Urban Walk': '#1E40AF',
  'Urban': '#1E40AF',
  'urban-walk': '#1E40AF',
  'urban': '#1E40AF',
};

export function categoryColor(value) {
  if (!value) return '#374151';
  return CATEGORY_COLORS[value] || '#374151';
}

const DIFFICULTY_COLORS = {
  'Easy': '#16A34A',
  'Moderate': '#F59E0B',
  'Hard': '#DC2626',
  'Challenging': '#DC2626',
};

export function difficultyColor(value) {
  return DIFFICULTY_COLORS[value] || '#374151';
}

export function distanceCategory(meters) {
  if (!meters || meters <= 0) return '';
  const miles = meters / 1609.34;
  if (miles < 2) return 'Short';
  if (miles <= 5) return 'Medium';
  if (miles <= 10) return 'Long';
  return 'Epic';
}

const DISTANCE_CAT_COLORS = {
  'Short': '#0D9488',
  'Medium': '#2563EB',
  'Long': '#7C3AED',
  'Epic': '#DC2626',
};

export function distanceCategoryColor(value) {
  return DISTANCE_CAT_COLORS[value] || '#374151';
}

export default function categoryLabel(slug) {
  if (!slug) return '';
  // Check the map first
  if (CATEGORY_MAP[slug]) return CATEGORY_MAP[slug];
  // If it's already a display label (legacy data), return as-is
  if (Object.values(CATEGORY_MAP).includes(slug)) return slug;
  // Fallback: de-slugify
  return slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
